import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import teamSectionMember from './teamSectionMember.js';
var schema = defineObject('teamSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    subtitle: {
        title: 'Subtitle',
        type: 'string'
    },
    members: {
        type: 'array',
        title: 'Members',
        of: [
            {
                type: 'teamSectionMember'
            }
        ]
    }
}, [
    teamSectionMember.schema.teamSectionMember
]);
var validator = z.object({
    title: z.string(),
    subtitle: z.string(),
    members: z.array(teamSectionMember.validator)
}).partial();
schema.teamSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=teamSection.js.map